import React, { Fragment, useEffect, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { GetNoticeList } from '../../common/actions/moreAction';
import { dateFormation, isEmpty, isMobilePage } from '../../common/cores';
// import {SlideDown} from '../../utils';
import Pagenation from '../common/Pagenation';
import BackButton from './BackButton';


const NoticeCustomContent = (props) => {

    const { page, notices, setVal, type } = props;
    const [showHis, setShowHis] = useState(false);
    // const [ notice , setNotice ] = useState({})
    const [active, setActive] = useState(0);
    // SlideDown();
    const showHisotry = () => {
        setShowHis(!showHis);
    }
    const getMessage = (page) => {

        if (page > 0) {
            const params = {
                page: page,
                perPage: 10
            }
            props.GetNoticeList(params);
        }
    }

    const onNotice = (index) => {
        // setNotice(notices[index]);
        setActive(index)
        showHisotry();
    }

    const notice = notices[active];

    useEffect(() => {

        getMessage(1);
    }, [])
    return (
        <Fragment>
            <div className="con_box10">
                {!isEmpty(notices) &&
                    notices.map((item, index) => {
                        return (
                            <Fragment key={index}>
                                <div className="qna_list">
                                    <div className="qna_text">{!isEmpty(item.title) && item.title}</div>
                                    <div className="qna_time">{!isEmpty(item.created_date) && dateFormation(item.created_date)}</div>
                                </div>
                                <div className="qna_view">
                                    <div className="qna_text2 notice-div white-break-spaces" dangerouslySetInnerHTML={{ '__html': !isEmpty(item.content) ? item.content : "내용이 없습니다" }}></div>
                                </div>
                            </Fragment>
                        )
                    })
                }

            </div>
            <Pagenation page={page.curPage}
                totalPage={page.totalPage}
                getPage={getMessage}
                perPage={10} />
        </Fragment>
    )
}

const mapStateToProps = state => ({
    page: state.page,
    notices: state.more.notice.notices
})

export default connect(mapStateToProps, { GetNoticeList })(NoticeCustomContent);


// WEBPACK FOOTER //
// ./src/components/account/NoticeCustomContent.js